import { useState, useCallback, useMemo } from 'react';
import { usePopper } from 'react-popper';
import debounce from 'lodash/debounce';
import { useKey } from 'react-use';

const getPopperOptions = () => ({
  placement: 'bottom-start',
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
  ],
});

export const useTooltip = (id) => {
  const [isOpen, setIsOpen] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, getPopperOptions());

  const showTooltip = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const debounceShowTooltip = useMemo(() => debounce(showTooltip, 400), [showTooltip]);

  const hideTooltip = useCallback(() => {
    setIsOpen(false);
    debounceShowTooltip.cancel();
  }, [setIsOpen, debounceShowTooltip]);

  useKey('Escape', hideTooltip);

  return {
    isOpen,
    triggerProps: {
      id,
      ref: setReferenceElement,
      onMouseEnter: debounceShowTooltip,
      onMouseLeave: hideTooltip,
      onFocus: showTooltip,
      onBlur: hideTooltip,
    },
    tooltipProps: {
      'aria-labelledby': id,
      ref: setPopperElement,
      style: styles.popper,
      ...attributes.popper,
      isOpen,
      zIndex: 'tooltip',
    },
  };
};
